module.exports = __webpack_public_path__ + "static/media/ie-support-notice.0a72ff2f.svg";